import DocViewer from './DocViewer.vue';
export default DocViewer;
